import Serializable from "@/core/misc/mixins/Serializable";

class CompanyAdditionalAttribute extends Serializable{
	/** псевдоним атрибута */
	public id: number;

	/** псевдоним атрибута */
	public alias: string;

	/** наименование */
	public name: string;

	/** значение */
	public value: string;

	/**
	 * Признак главного налогового/регистрационного реквизита компании в стране
	 * (ИНН, БИН, УНП, USCC, VAT и т.п.). Уникален в пределах страны — один на country_code.
	 */
	public isTin: boolean;

	public static fromServer(data: any, result = new CompanyAdditionalAttribute()): CompanyAdditionalAttribute {
		super.fromServer(data, result);
		return result;
	}

	toString(): string {
		return this.value ?? '';
	}
}

export default CompanyAdditionalAttribute;